import {
	FETCH_SUCCESS,
	UPDATE_PAGES_RESULT,
	UPDATE_PAGE_NUMBER,
	LOADING_BEHAVIOR,
	RESET_INFINITE,
	RESET_AND_SAVE_INFINITE,
	RESTORE_INFINITE,
	filterPageResult
} from '../actions/InfiniteScrollActions';

const state = {
	id: null,
	loadType: null,
	path: null,
	page: 1,
	totalPages: 1,
	earliestLoadedPage: 1,
	latestLoadedPage: 1,
	pages: [],
	scrollDirection: null
};

const initialState = {
	...state,
	prevState: state
};

export default function infiniteScroll(prevState = initialState, action) {

	let scrollDirection = null;

	if( parseInt( prevState.page ) > parseInt( action.page ) ) {
		scrollDirection = "up"
	} else if( parseInt( prevState.page ) < parseInt( action.page ) ) {
		scrollDirection = "down"
	}

	switch (action.type) {
		case FETCH_SUCCESS:
			if( action.loadingBehavior === LOADING_BEHAVIOR.REFRESH ) {
				return {
					...prevState,
					id: action.id,
					loadType: action.loadType,
					page: action.page,
					earliestLoadedPage: action.page,
					latestLoadedPage: action.page,
					pages: [ action.page ],
					totalPages: action.totalPages,
					scrollDirection: null
				}
			} else {
				let earliestLoadedPage = prevState.earliestLoadedPage;
				let latestLoadedPage = prevState.latestLoadedPage;

				if( action.loadingBehavior === LOADING_BEHAVIOR.PREPEND && action.page < earliestLoadedPage ) {
					earliestLoadedPage -= 1;
				} else if(
					action.loadingBehavior === LOADING_BEHAVIOR.APPEND
					&& action.page > latestLoadedPage
					&& action.page <= prevState.totalPages
				) {
					latestLoadedPage += 1;
				}

				return {
					...prevState,
					id: action.id,
					loadType: action.loadType,
					page: prevState.page, // Don't update since this is infinite scrolling and we may not have actually scrolled all the way to that page yet
					pages: filterPageResult( prevState.page, earliestLoadedPage, latestLoadedPage ),
					earliestLoadedPage,
					latestLoadedPage,
					scrollDirection
				}
			}

		case UPDATE_PAGE_NUMBER:
			return {
				...prevState,
				page: action.page,
				scrollDirection
			};

		case UPDATE_PAGES_RESULT:
			let pages = filterPageResult( prevState.page, prevState.earliestLoadedPage, prevState.latestLoadedPage );
			return {
				...prevState,
				pages,
				scrollDirection
			};

		case RESET_INFINITE:
			return initialState;

		case RESET_AND_SAVE_INFINITE:
			return {
				...initialState,
				prevState: prevState
			};

		case RESTORE_INFINITE:
			return prevState.prevState || initialState;

		default:
			return prevState;
	}
}




// WEBPACK FOOTER //
// ./common/reducers/infinitescroll.js